import React from "react";
import { Box, Typography, Card, CardContent, Chip } from "@mui/material";

const SynonymsInfoBox = ({ topSkillValidity }) => {
  // Check if topSkillValidity is null, undefined, or has no items
  if (!topSkillValidity || topSkillValidity.length === 0) {
    return null; // Do not render the component
  }

  // Check if topSkillValidity has only one item and that item does not have synonyms
  const shouldRender = !(
    topSkillValidity.length === 1 &&
    (!topSkillValidity[0]?.synonyms ||
      topSkillValidity[0]?.synonyms.length === 0)
  );

  if (!shouldRender) {
    return null; // Do not render the component
  }

  return (
    <Box
      sx={{
        mt: 4,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          border: "1px solid rgba(102,82,228,0.25)",
          borderRadius: "15px",
          boxShadow: "0px 0px 8px 0px #D9D9FF",
        }}
      >
        <CardContent>
          <Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#6652E4",
                mb: 2,
                fontFamily: "Poppins",
              }}
            >
              Synonymous Skills
            </Typography>
            {topSkillValidity.map(
              (skill) =>
                skill.synonyms?.length > 0 && ( // Render only if synonyms exist
                  <Box key={skill._id} sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: 600,
                          color: "#262655",
                          mb: 0.5,
                          fontFamily: "Poppins",
                        }}
                      >
                        {skill.name}:
                      </Typography>
                      {skill.synonyms.map((synonym, index) => (
                        <Chip
                          key={index}
                          label={synonym}
                          sx={{
                            backgroundColor: "#F3F4FF",
                            color: "#262655",
                            fontWeight: 500,
                            fontFamily: "Poppins",
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                )
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SynonymsInfoBox;
